import { Role } from "@/router/_helper";

  const program = {
    path: "/program",
    name: "program",
    component: () => import(/* webpackChunkName: "program" */ "@/components/program/ProgramIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "program" */ "@/components/program/ProgramView.vue"), name: "programView", meta: { authorize: [Role.ManageSettings], requiresAuth: true } },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "program" */ "@/components/program/ProgramEdit.vue"), name: "programEdit", meta: { authorize: [Role.ManageSettings], requiresAuth: true } },
      { path: "create", component: () => import(/* webpackChunkName: "program" */ "@/components/program/ProgramCreate.vue"), name: "programCreate", meta: { authorize: [Role.ManageSettings], requiresAuth: true }}
    ],
    meta: { authorize: [Role.ManageSettings], requiresAuth: true }
  };

export default program;
    